import SglContext from "../SglContext";
import Loginform from "../loginForm/loginForm";
import { Link } from "react-router-dom";

const axios = require("axios").default;
const { useState, useEffect, useContext } = require("react");


function Entries(props) {

  const [entries, setEntries] = useState([]);
  const [request_entries, setRequestEntries] = useState([]);
  const [shows_list, setShowsList] = useState([]);
  const [current_show, setCurrentShow] = useState(
    localStorage.getItem("show_id")
  );
  const [total_entries, setTotalEntries] = useState(0);
  const [display_entries, setDisplayEntries] = useState(0);
  const [timeout, setTimeout] = useState(null);
  const [loading, setLoading] = useState(true);
  const Sgl = useContext(SglContext);
  const [people_id, setPeopleId] = useState(0);
  const [switch_allowed, setSwitchAllowed] = useState(0);



  useEffect(() => {
    getAllData(props.current_show);
    var switches = Sgl.switches.switches;
    var switch_found = switches.find(el => el.switch_name === "Edit Entry");
    if(switch_found){
        setSwitchAllowed(switch_found.value);
    }
  }, [props.current_show, props.current_user, Sgl.currentTeamId]);

  const getAllData = (show) => {
    axios
      .all([
        axios.get(Sgl.nestApiUrl + "/entries/my", {
          params: {
            show_id: show,
            customer_id: Sgl.company_id,
            login_user_id: Sgl.current_user.sgl_id,
            team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
          },
        }),
      ])
      .then(
        axios.spread((res) => {
          if (res.data.user_logged_id) {
            setEntries(res.data.entries);
            setCurrentShow(res.data.show_id);
            setTotalEntries(res.data.total_entries);
            setDisplayEntries(
              res.data.total_entries > 10 ? 10 : res.data.total_entries
            );
            setRequestEntries(res.data.request_entries);
            setLoading(false);
            setPeopleId(res.data.people_id);

            // document.title = "My Entries";
            // Sgl.reportToGA( "/sgl-wp-plugin/" + Sgl.company_urlpath + "/" + current_show + "/my-entries" );
          } else {
            setEntries([]);
            setTotalEntries(0);
            setLoading(true);
          }
        })
      );
  };

  const ViewMore = () => (e) => {
    var entries_to_display = display_entries + 10;
    if (entries_to_display > entries.length) {
      entries_to_display = entries.length;
    }
    setDisplayEntries(entries_to_display);
  };

  const getDisplayEntries = () => {
    var rows = [];
    if (total_entries > 0) {
      for (var i = 0; i < display_entries; i++) {
        var entry = entries[i];
        if (!entry) continue;
        rows.push(
          <li
            className={[
              "my_entries_li",
              entry.scratched ? "strike_out" : "",
            ].join(" ")}
          >
            <Link
              to={
                "/entries/detail?eid=" + entry.entry_id + "&sid=" + current_show
              }
            >
              <span className="my_entries_id_span right-align">
                <b>{entry.number}</b>
              {/* </span>
              <span className="inline_margin_list"> */}
                {" "}
                - {!entry.trainer_account ? entry.horse : "TRAINER ACCOUNT"}
              </span>
            </Link>
            { ( people_id == entry.trainer_id && switch_allowed ) ? (
              <span class="edit-entry-link">
                <Link to={`/edit-entry/?eid=${entry.entry_id}&sid=${entry.show_id}`} ><i class="fa fa-pen-to-square edit-entry-icon" ></i></Link>
              </span> 
            ) : null }
          </li>
        );
      }
    } else {
      rows.push(
        <li className="no_entries_li">
          <div className="title">You have no entries in this show.</div>
        </li>
      );
    }
    return rows;
  };



  if (loading) {
    return null;
  }

  return (
    <div className="sgl-plugin myentriesbox">


      <div className="my-entries-area">
        <div className="div-responsive my-entries-content">
          <div className="class-details primary-header sgl-primary-header">
            <p className="ring-name sgl-nm-ring-name my-entries-header">
              My Entries
            </p>
            <div className="right-align">
              <span className="round sgl-round">{total_entries}</span>
            </div>
          </div>
          <ul style={{ display: "block" }}>{getDisplayEntries()}</ul>
        </div>
        {total_entries > display_entries && (
          <div className="bottomdiv view-more-btn">
            <button className="bottom-button-trans" onClick={ViewMore()}>
              View More...
            </button>
          </div>
        )}
      </div>
      {request_entries.length > 0 && (
        <div className="div-responsive">
          <table className="table table-striped  table-hover">
            <thead>
              <tr>
                <th>PENDING ENTRIES</th>
              </tr>
            </thead>
            <tbody>
              {request_entries.map((entry, index) => {
                return (
                  <tr>
                    <td>{entry.horse}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default Entries;
